"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  init: true
};
exports.init = init;

var _base = require("./base");

var _interface = require("./interface");

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interface[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});

// import { PhoneNumberUtil } from "google-libphonenumber";
// const phoneUtil = PhoneNumberUtil.getInstance();
var _inited; // 从localStorage取缓存


function getInfoFromCache(key) {
  if (window.localStorage.getItem(key)) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '');
    } catch (e) {
      console.warn('Elvish Warning: JSON.parse error');
      return false;
    }
  } else {
    console.warn('Elvish Warning: no cache');
    return false;
  }
} // 存储到localStorage中


function setIntoCache(key, config) {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem(key, JSON.stringify(config));
  }
} // 获取cdn配置并存储到缓存中


function getRemoteConfg() {
  return fetch("https://static.didiglobal.com/ibt/elvish/countryTimezone.json").then(function (res) {
    return res.json();
  }).then(function (res) {
    setIntoCache('elvishCountryTimezone', res);
    return (0, _base.initBase)(res);
  }).then(function () {
    _inited = true;
  })["catch"](function (err) {
    console.warn('ELvish Warning: fetch countryTimezone.json error'); // 如果拉取cdn配置失败，如果storage里有缓存，就取storage的缓存

    if (typeof window !== "undefined" && window.localStorage) {
      try {
        var cacheConfig = JSON.parse(window.localStorage.getItem('elvishCountryTimezone') || '');
        return (0, _base.initBase)(cacheConfig).then(function () {
          _inited = true;
        });
      } catch (e) {
        throw Error('Elvish Fetch Error: 请求countryTimezone配置出错且无缓存可用');
      }
    }
  });
}

function init(config) {
  var ifCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (_inited) return new Promise(function (resolve) {
    return resolve();
  });

  if (config) {
    return (0, _base.initBase)(config.countryTimezone).then(function () {
      _inited = true;
    });
  } else {
    // 在浏览器环境下，并且ifCache为true，就优先取缓存
    if (typeof window !== "undefined" && window.localStorage && ifCache) {
      var cacheConfig = getInfoFromCache('elvishCountryTimezone');

      if (!cacheConfig) {
        // 如果没取到缓存，则从cdn拉取
        return getRemoteConfg();
      }

      return (0, _base.initBase)(cacheConfig).then(function () {
        _inited = true;
        fetch("https://static.didiglobal.com/ibt/elvish/countryTimezone.json").then(function (res) {
          return res.json();
        }).then(function (res) {
          setIntoCache('elvishCountryTimezone', res);
        })["catch"](function (err) {
          console.warn(err);
          console.warn('Elvish Warning: update countryTimezone localStorage error');
        });
      });
    } else {
      return getRemoteConfg();
    }
  }
} // 根据国家码查询国家电话码
// export function getTelPrefix(countryCode) {
//   const res = phoneUtil.getExampleNumber(countryCode).getCountryCode();
//   return res ? '+' + res : '';
// }